import {
  LOADING_UNREAD_COUNTS,
  NEW_PUSHER_MESSAGE,
  SET_ERROR_SENDING_MESSAGE_BOOLEAN,
  SET_NEW_THREAD_MODAL_VISIBILITY,
  SET_THREAD_LIST_UPDATED,
  SET_THREAD_USERS_MODAL_VISIBILITY,
  SET_UNREAD_CONSTRAINTS,
  SET_USER_UNREAD_MESSAGES,
  UPDATE_THREAD_LIST,
} from 'redux/actions/types' // eslint-disable-line

const defaultState = {
  newThreadModalOpen: false,
  userUnreadMessageCount: '0',
  newThreadModalVisible: false,
  threadUsersModalVisible: false,
  unreadConstraints: {
    portfolioId: null,
  },
  newThreadMessage: {},
  updateThreadList: 0, // start from a 0 value, it's going to get updated anyway
  updateSource: null,
  unreadCountStatus: {
    loading: false,
    error: false,
  },
}

const threadsState = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case LOADING_UNREAD_COUNTS:
      return {
        ...state,
        unreadCountStatus: payload,
      }
    case SET_USER_UNREAD_MESSAGES:
      return {
        ...state,
        ...{
          userUnreadMessageCount: payload,
        },
      }
    case SET_ERROR_SENDING_MESSAGE_BOOLEAN:
      return {
        ...state,
        ...{
          errorSendingMessage: payload,
        },
      }
    case SET_NEW_THREAD_MODAL_VISIBILITY:
      return {
        ...state,
        ...{
          newThreadModalVisible: payload,
        },
      }
    case SET_THREAD_USERS_MODAL_VISIBILITY:
      return {
        ...state,
        ...{
          threadUsersModalVisible: payload,
        },
      }
    case NEW_PUSHER_MESSAGE:
      return {
        ...state,
        ...{
          newThreadMessage: payload,
        },
      }
    case UPDATE_THREAD_LIST:
      return {
        ...state,
        ...{
          updateThreadList: Date.now(),
          updateSource: payload?.source,
        },
      }
    case SET_THREAD_LIST_UPDATED:
      return {
        ...state,
        ...{
          updateThreadList: defaultState.updateThreadList,
        },
      }
    case SET_UNREAD_CONSTRAINTS:
      return {
        ...state,
        unreadConstraints: payload?.unreadConstraints,
      }
    default:
      return state
  }
}

export default threadsState
